export const LEVEL = '/level/' as const
export const LEVEL_ALL = `${LEVEL}all` as const
